import type { MtmWidgetProfile } from './types';

function isValidEmail(value: string | null | undefined) {
  return Boolean(value && value.length > 3 && value.includes('@'));
}

export function buildMtmWidgetSessionState(
  profile: MtmWidgetProfile,
  options: { status?: string; mtmClientId?: number; processStatus?: string } = {},
) {
  const email = profile.defaultValues.email ?? profile.userContext?.email ?? '';
  const firstName = profile.firstName?.trim() || null;
  const disableEmail = profile.disableScreen.email && isValidEmail(email);

  return {
    store: typeof __STORE_NAME__ === 'string' && __STORE_NAME__ ? __STORE_NAME__ : 'vadauro',
    ...(options.status ? { status: options.status } : {}),
    ...(options.processStatus !== undefined ? { processStatus: options.processStatus } : {}),
    ...(options.mtmClientId ? { mtmClientId: options.mtmClientId } : {}),
    units: 'cm',
    email,
    ...(firstName ? { firstName } : {}),
    disabledEmail: disableEmail,
    disableEmailScreen: disableEmail,
    ...(firstName
      ? {
          disabledName: true,
          disableNameScreen: true,
        }
      : {}),
  };
}
